document.addEventListener("DOMContentLoaded", function () {
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  const videoPauseButton = document.querySelectorAll(
    ".video-pause-button button",
  );
  if (videoPauseButton.length > 0) {
    videoPauseButton.forEach((button) => {
      button.addEventListener("click", function () {
        const video = this.closest(
          ".video-pause-button",
        ).parentElement.querySelector("video");
        if (video) {
          if (video.paused) {
            video.play();
            this.parentElement.classList.add("is-playing");
            this.parentElement.classList.remove("is-paused");
            this.setAttribute("aria-label", "Pause video");
            this.querySelector("span").innerText = "Pause video";
          } else {
            video.pause();
            this.parentElement.classList.add("is-paused");
            this.parentElement.classList.remove("is-playing");
            this.setAttribute("aria-label", "Play video");
            this.querySelector("span").innerText = "Play video";
          }
        }
      });
      if (prefersReducedMotion) {
        const video = button
          .closest(".video-pause-button")
          .parentElement.querySelector("video");
        if (video) {
          video.pause();
          button.parentElement.classList.add("is-paused");
          button.parentElement.classList.remove("is-playing");
          button.setAttribute("aria-label", "Play video");
          button.querySelector("span").innerText = "Play video";
        }
      }
    });
  }
});
